import { Add } from '@project-lary/react-material-symbols';
import SendButton from 'gcs-common/components/SendButton/SendButton';
import { FormControl, FormField, FormItem } from 'gcs-common/design-system/ui/form';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import type { ChangeEvent, KeyboardEvent } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import { useFormContext } from 'react-hook-form';

type EtsMessageInputProps = {
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isSubmitting: boolean;
};

const EtsMessageInput = ({ handleFileChange, isSubmitting }: EtsMessageInputProps) => {
  const { control, formState } = useFormContext();
  const isSendDisabled = !formState.isValid || isSubmitting;

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (!isSendDisabled) {
        event.currentTarget.form?.requestSubmit();
      }
    }
  };

  return (
    <div className="flex items-center gap-2 bg-neutral-1 px-4 py-3">
      <div className="flex items-center">
        <label className="cursor-pointer">
          <IconButton Icon={Add} size="base" iconSize="text-2xl" variant="ghost_neutral" />
          <input type="file" className="hidden" multiple onChange={handleFileChange} />
        </label>
      </div>

      <div className="flex-grow">
        <FormField
          control={control}
          name="comment"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <TextareaAutosize
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                  id="automated-qa-ticket-comment-input"
                  {...field}
                  placeholder="Nachricht schreiben"
                  className="box-border max-h-[150px] w-full resize-none rounded-[20px] bg-white py-2 pl-4 text-base ring-1 ring-neutral-5 placeholder:text-neutral-9 focus:ring-neutral-5"
                  maxRows={4}
                  onKeyDown={handleKeyDown}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>

      <SendButton type="submit" id="send-button" isLoading={isSubmitting} disabled={isSendDisabled} />
    </div>
  );
};

export default EtsMessageInput;
